export default "__VITE_ASSET__BnZe_Pqa__"